import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';

@Injectable()
export class AuthenticationInterceptor implements HttpInterceptor {

  constructor(
    private router: Router,
    // Retained only to clear the unrelated 'license' cookie on a 401 -- see the matching comment in
    // AuthenticationService. Session data (access-token, expires, ...) now lives in localStorage,
    // not cookies: a single cookie is capped at ~4096 bytes by every major browser (silently dropped,
    // no error, if exceeded), and the access-token JWT can exceed that for accounts with many
    // roles/modules enabled.
    private cookieService: CookieService) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.url.startsWith('assets/') || req.url.includes('/assets/')) {
      return next.handle(req);
    }

    if (req.headers.get('No-Auth') === 'True') {
      const clonedReq = req.clone({
        headers: new HttpHeaders({
          'Content-Type': req.headers.get('Content-Type')
        })
      });

      return next.handle(clonedReq);
    }

    const token = localStorage.getItem('access-token');

    if (!token) {
      this.router.navigateByUrl('/account/login');
      return throwError({ message: 'No access token available.' });
    }

    const clonedRequest = req.clone({
      headers: req.headers.set('Authorization', 'Bearer ' + token)
    });

    return next.handle(clonedRequest).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          localStorage.removeItem('access-token');
          localStorage.removeItem('expires');
          localStorage.removeItem('username');
          localStorage.removeItem('usericon');
          localStorage.removeItem('companyname');
          localStorage.removeItem('setup2fa');
          this.cookieService.delete('license', '/');

          this.router.navigateByUrl('/account/login');
        }

        return throwError(error);
      })
    );
  }
}
